import { IconRefresh } from "@tabler/icons-react"
import { motion } from "motion/react"
import { type FC } from "react"

import { useIsOutdated } from "../contexts/VersionContext"

const ClientOutdatedToast: FC = () => {
	const isOutdated = useIsOutdated()

	if (!isOutdated) return null

	return (
		<motion.div
			className="border-component-border bg-component-background fixed top-4 right-4 flex max-w-sm items-center gap-4 rounded-2xl border py-3.5 pr-4 pl-5 shadow-xl"
			initial={{ opacity: 0, x: 20, scale: 0.98 }}
			animate={{ opacity: 1, x: 0, scale: 1 }}
			transition={{ type: "spring", stiffness: 380, damping: 28 }}
			role="status"
			aria-live="polite"
		>
			<div className="bg-primary absolute top-3 bottom-3 left-1 w-1 rounded-full" />
			<p className="min-w-0 flex-1 text-sm leading-snug font-medium text-black/90">A new version is available!</p>
			<motion.button
				type="button"
				onClick={() => window.location.reload()}
				className="bg-primary hover:bg-primary/90 active:bg-primary/80 flex shrink-0 cursor-pointer items-center gap-2 rounded-xl px-3.5 py-2 text-sm font-semibold text-white transition-colors"
				whileHover={{ scale: 1.02 }}
				whileTap={{ scale: 0.98 }}
			>
				<IconRefresh className="size-4 shrink-0" aria-hidden />
				Refresh
			</motion.button>
		</motion.div>
	)
}

export default ClientOutdatedToast
